import { render, staticRenderFns } from "./BaseOverlay.vue?vue&type=template&id=7cb306e3&"
import script from "./BaseOverlay.vue?vue&type=script&lang=js&"
export * from "./BaseOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BaseOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports